import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useI18n } from '../../i18n/I18nContext';

const SuperAdminLayout = ({ children }) => {
    const { logout, user } = useAuth();
    const { t } = useI18n();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const navItems = [
        { path: '/superadmin/setup', label: t('System Setup') },
        { path: '/superadmin/tenants', label: t('Tenants') },
        { path: '/superadmin/users', label: t('Global Users') },
    ];

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col">
            <header className="bg-white shadow-md px-6 py-4 flex justify-between items-center">
                <div className="flex items-center space-x-8">
                    <h1 className="text-xl font-bold text-gray-800">SuperAdmin</h1>
                    <nav className="flex space-x-4">
                        {navItems.map(item => (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                className={({ isActive }) => 
                                    `px-3 py-2 rounded-md text-sm font-medium ${
                                        isActive ? 'bg-gray-900 text-white' : 'text-gray-600 hover:bg-gray-200'
                                    }`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
                <div className="flex items-center space-x-4">
                    <span className="text-sm text-gray-600">{user?.email}</span>
                    <button
                        onClick={handleLogout}
                        className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded text-sm transition"
                    >
                        {t('Logout')}
                    </button>
                </div>
            </header>
            <main className="flex-1 container mx-auto py-6">
                <div className="bg-white shadow rounded-lg">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default SuperAdminLayout;
